<template>
    <div class="Index">
        <div class="content" :style="{backgroundImage:`url(${ImageUrl})`}">
            <!-- <img src="../assets/book.png" class="img-fluid" alt="Responsive image"> -->
            <div class="content-detail">
                <h1 data-delighter class="left" style="color: #5fe0c6;">B2C</h1>
                <h1 data-delighter class="right">共享打印解决方案（手机自助打印、远程打印）</h1>
                <p data-delighter class="left">借助印点点自助打印系统，将传统打印机升级为自助打印机，</p>
                <p data-delighter class="right">投放到便利店、文具店、自习室等场所，面向用户提供自助打印、自助洗相、自助证件照来实现盈利。</p>
            </div>
        </div>
        <!-- content开始 -->
        <div class="container">
            <div class="row content-one">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 local">
                    <div class="card-deck">
                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <img class="card-img" src="../assets/book-1.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">自助打印，省力省心</h5>
                            </div>
                        </div>
                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <img class="card-img" src="../assets/book-2.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">合作共建模式，成单无忧</h5>
                            </div>
                        </div>
                        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <img class="card-img" src="../assets/book-3.png" alt="Card image cap">
                            <div class="card-body">
                                <h5 class="card-title title">让客户零投资，上服务</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="card-deck card-list">
                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                            <img class="icon icon-1" src="../assets/book-6.png" alt="Card image cap">
                        </div>
                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                            <h2>自助打印，省力省心</h2>
                            <p>微信支付，自动结算，无需设置服务台及服务人员，省去人工服务成本。</p>
                            <p>智能自助式服务，用户满意度高。</p>

                            <div class="row part">
                                <div class="col-4 col-md-4 area">
                                    <h1>方便</h1>
                                    <h5>微信支付自动结算</h5>
                                </div>
                                <div class="col-4 col-md-4 area">
                                    <h1>智能</h1>
                                    <h5>智能自助服务</h5>
                                </div>
                                <div class="col-4 col-md-4 area">
                                    <h1>高效</h1>
                                    <h5>提高工作效率</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dark">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>合作共建模式，成单无忧</h2>
                                <p>采用“先租机，后分成”合作共建模式，与客户联合运营。绕开大宗采购招</p>
                                <p>标流程，成单无忧。</p>

                                <div class="row part">
                                    <div class="col-4 col-md-4 area">
                                        <h1>共赢</h1>
                                        <h5>合作共建模式</h5>
                                    </div>
                                    <div class="col-4 col-md-4 area">
                                        <h1>高效</h1>
                                        <h5>提高工作效率</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon icon-2" src="../assets/book-4.png" alt="Card image cap">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="">
            <div class="container">
                <div class="row content-one">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="card-deck card-list">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-icon">
                                <img class="icon icon-3" src="../assets/book-5.png" alt="Card image cap">
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 list-item">
                                <h2>让客户零投资，上服务</h2>
                                <p>自助服务，免去人力成本，租赁模式，无需管理资产。</p>

                                <div class="row part">
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>零投资</h1>
                                        <h5>租赁模式，无需投资</h5>
                                    </div>
                                    <div class="col-4 col-sm-4 col-md-4 .col-lg-4 col-xl-4 area">
                                        <h1>低成本</h1>
                                        <h5>自助服务，免人力</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "Index",
  data() {
    return {
        ImageUrl:require('../assets/book.png')
    };
  },
  created() {

    window.scrollTo(0, 0);
  }
};
</script>

<style lang="stylus" scoped>
.content {
    width: 100%;
    position: relative;
    height: 535px;
    background: no-repeat center center;
    background-size: cover;
}

.local {
    margin: -64px auto 0;
}

.icon-2 {
    width: 423px;
    height: 234px;
}

.icon-3 {
    width: 431px;
    height: 184px;
}

.icon-1 {
    width: 370px;
    height: 354px;
}

.card-list {
    padding: 200px 0 158px;
}

.list-icon {
    position: relative;
    display: flex;
    justify-content: center;
}

.icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.list-item {
    text-align: left;

    h2 {
        font-size: 40px;
        line-height: 28px;
        color: #18182a;
        margin-bottom: 24px;
    }

    p {
        font-size: 16px;
        line-height: 28px;
        color: #555;
    }

    .part {
        text-align: center;
        margin-top: 100px;

        .area {
            border-right: 1px solid rgba(193, 224, 249, 0.3);

            h1 {
                font-size: 50px;
                line-height: 28px;
                color: #006ecf;
                margin: 0 0 20px 0 !important;
            }

            h5 {
                font-size: 16px;
                line-height: 28px;
                color: #006ecf;
                margin: 0 !important;
            }

            &:last-child {
                border-right: 0 !important;
            }
        }
    }
}

.dark {
    background-color: #f8fcff;
}

.content-detail {
    position: absolute;
     top: 178px;
    left: 405px;

    h1 {
        font-size: 2.5rem;
        font-weight: 100 !important;
        line-height: 2rem;
        color: #fff;
    }

    p {
        color: #fff;
    }
}

.card-img {
    width: 118px;
    height: 118px;
    margin: 0 auto;
    transition: width 1s linear 2s;
    -webkit-transition: width 1s height 1s linear 2s;
}

.title {
    font-size: 16px !important;
    font-weight: bold;
}

.clear {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

// 多场景解决方案
.card-over {
    padding: 8rem 2rem !important;

    .line {
        width: 40px;
        height: 2px;
        margin: 30px auto;
        background-color: #fff;
    }

    p, button {
        opacity: 0;
    }
}

// 多场景解决方案鼠标移动效果
.clear:hover {
    position: relative;

    .card-over {
        padding: 2.25rem !important;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .mask {
        width: 300px;
        height: 480px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(24, 121, 240, 0.6);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .line {
        display: none;
    }

    p, button {
        opacity: 1;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    h5 {
        margin-top: 10px;
    }

    p {
        margin: 20px 0 50px;
    }
}

.carouse-img {
    width: 100%;
    height: 640px;
}

.content-one {
    text-align: center;
}

.margin-top {
    margin-top: 150px;
}

.content-last {
    position: relative;
}

.content-last-img {
    width: 275px;
    height: 250px;
}

.card-kind {
    padding: 20px 0;
    border: 0 !important;
}

.card-kind:hover {
    h5 {
        color: #30bbfc;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    }
}

.card-deck .card {
    margin-bottom: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ShareSolution.vue